module.exports = __webpack_public_path__ + "static/ticket-volume-hero-ea2e025e265644c9b011da3cce41308d.png";